// Adapter for query-string on the web bundle.
// The app's `import qs from 'query-string'` wants a default object; but
// @react-navigation/core does `import * as queryString from 'query-string'`
// and reads named `parse`/`stringify`. The root v8 exposes those named exports
// from ./base.js (the `$` alias below only rewrites the bare specifier, so this
// subpath still resolves to the real package). Re-export both shapes.
// Relative path (not the bare specifier) bypasses query-string's `exports` map,
// which otherwise blocks the ./base.js subpath.
import * as all from '../../node_modules/query-string/base.js'

export const parse = all.parse
export const stringify = all.stringify
export const extract = all.extract
export const parseUrl = all.parseUrl
export const stringifyUrl = all.stringifyUrl
export const pick = all.pick
export const exclude = all.exclude

export default all
